import ReactDOM from 'react-dom/client';
import { initOpenReplay } from './utils/openreplay';
import AppRuntime from '@platform/client/runtime/AppRuntime';
import { ensureServiceWorkerRegistration } from '@platform/client/pwa/registerServiceWorker';
// import logger from '@platform/common/helpers/logger';
// import { StrictMode } from 'react';

// Mantine Core styles (базовые стили UI библиотеки)
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/tiptap/styles.css";
import "@mantine/notifications/styles.css";

initOpenReplay();

// Регистрируем Service Worker сразу, чтобы PWA и push работали до авторизации
void ensureServiceWorkerRegistration();

await AppRuntime.getInstance().init();

// Важно: импортируем App динамически ПОСЛЕ инициализации рантайма,
// чтобы Router.tsx сформировал маршруты из AppRuntime.getRouteConfig()
const { default: App } = await import('./App');

const root = document.getElementById('root');

if (root) {
  ReactDOM.createRoot(root).render(
    // <StrictMode>
      <App />
    // </StrictMode>
);
} else {
  // eslint-disable-next-line no-console
  console.error('No root div');
}
